import { ActionsUnion, createAction } from 'spw-redux/types';
import { IProjectSpaceType } from 'spw-redux/modules/space_types/types';
import { PlainWorksheet } from '../../../../models/Worksheet';
import { UpdateWorksheetRowsBySpaceTypePayload } from './types';

export const CLEAN_BULK_EDIT_DIALOG_DATA =
  'ps/prog/CLEAN_BULK_EDIT_DIALOG_DATA';
export const GET_WORKSHEETS_USING_SPACE_TYPE =
  'ps/prog/GET_WORKSHEETS_USING_SPACE_TYPE';
export const GET_WORKSHEETS_USING_SPACE_TYPE_SUCCEDED =
  'ps/prog/GET_WORKSHEETS_USING_SPACE_TYPE_SUCCEDED';
export const CLEAN_WORKSHEETS_USING_SPACE_TYPE =
  'ps/prog/CLEAN_WORKSHEETS_USING_SPACE_TYPE';
export const UPDATE_WORKSHEET_ROWS_BY_SPACE_TYPE =
  'ps/prog/UPDATE_WORKSHEET_ROWS_BY_SPACE_TYPE';
export const INCREASE_POSITIONABLE_PS_DIALOG_COUNTER =
  'ps/prog/INCREASE_POSITIONABLE_PS_DIALOG_COUNTER';
export const DECREASE_POSITIONABLE_PS_DIALOG_COUNTER =
  'ps/prog/DECREASE_POSITIONABLE_PS_DIALOG_COUNTER';

export const cleanBulkEditDialogData = () =>
  createAction(CLEAN_BULK_EDIT_DIALOG_DATA);

export const getWorksheetsUsingSpaceType = (
  projectSpaceType: Partial<IProjectSpaceType>
) => createAction(GET_WORKSHEETS_USING_SPACE_TYPE, { projectSpaceType });

export const getWorksheetsUsingSpaceTypeSucceded = (
  worksheets: PlainWorksheet[]
) =>
  createAction(GET_WORKSHEETS_USING_SPACE_TYPE_SUCCEDED, {
    worksheets,
  });

export const cleanWorksheetsUsingSpaceType = () =>
  createAction(CLEAN_WORKSHEETS_USING_SPACE_TYPE);

export const updateWorksheetRowsBySpaceType = (
  payload: UpdateWorksheetRowsBySpaceTypePayload & { callback: () => void }
) => createAction(UPDATE_WORKSHEET_ROWS_BY_SPACE_TYPE, payload);

export const increasePositionablePSDialogCounter = () =>
  createAction(INCREASE_POSITIONABLE_PS_DIALOG_COUNTER);
export const decreasePositionablePSDialogCounter = () =>
  createAction(DECREASE_POSITIONABLE_PS_DIALOG_COUNTER);

export const actions = {
  cleanBulkEditDialogData,
  getWorksheetsUsingSpaceType,
  getWorksheetsUsingSpaceTypeSucceded,
  cleanScenarioIdsUsingSpaceType: cleanWorksheetsUsingSpaceType,
  updateWorksheetRowsBySpaceType,
  increasePositionablePSDialogCounter,
  decreasePositionablePSDialogCounter,
};

export type Actions = ActionsUnion<typeof actions>;
